export const sumSuffix = 'Sum';
export const meanSuffix = 'Mean';

const kpisTextMapping = {
    revenue: {
        name: 'Revenue',
        tooltip: 'The total amount of revenue generated',
        suffix: sumSuffix
    },
    revenueSOV: {
        name: 'Revenue SOV',
        key: 'revenueSOV',
        tooltip: 'SOV (share of voice) reflects the bidding ad sources revenue share compared to total revenue from both bidding and non-bidding ad sources',
        suffix: meanSuffix
    },
    impressions: {
        name: 'Impressions',
        key: 'impressions',
        tooltip: 'Total number of times the ad is shown',
        suffix: sumSuffix
    },
    eCPM: {
        tooltip: 'Effective cost per thousand Impressions; calculated as (Revenue / Impressions) * 1000',
        key: 'eCPM',
        name: 'eCPM',
        suffix: meanSuffix
    },
    bidRequests: {
        name: 'Bid Requests',
        key: 'bidRequests',
        tooltip: 'The total number of times an ad source was requested to offer a bid',
        suffix: sumSuffix
    },
    bidResponse: {
        name: 'Bid Response',
        key: 'bidResponse',
        tooltip: 'The total number of times an ad network responded to bid requests',
        suffix: sumSuffix
    },
    wins: {
        name: 'Wins',
        key: 'wins',
        tooltip: 'The total number of times the an ad source won the auction',
        suffix: sumSuffix
    },
    renderRate: {
        name: 'Render Rate',
        key: 'renderRate',
        tooltip: 'The Total number of impressions divided by the total number of bid responses',
        suffix: meanSuffix
    },
    winRate: {
        name: 'Win Rate',
        key: 'winRate',
        tooltip: 'The total number ad source wins divided by the total number of bid Responses',
        suffix: meanSuffix
    },
    bidRate: {
        name: 'Bid Rate',
        key: 'bidRate',
        tooltip: 'Total number of bid responses divided by total number of bid requests',
        suffix: meanSuffix
    },
    bidResponseTime: {
        name: 'Bid Response Time',
        key: 'bidResponseTime',
        tooltip: 'The average time takes an ad network to respond to bid request',
        trendPercent: 2,
        suffix: meanSuffix
    }
};
export default kpisTextMapping;
